<template>
  <div class="event-treatment-detail d-flex align-items-center justify-content-start">
    <div class="event-treatment-detail__title">
      {{ treatment.full_name }}
    </div>

    <div v-if="!is_appointment" class="event-treatment-detail__is-appointed" :class="{ appointed: is_appointed }">
      <span v-if="is_appointed">Agendado</span>
      <span v-else @click="openAgenda">Sin Agendar</span>
    </div>

    <div class="event-treatment-detail__status" :class="{ done: is_done }" @click="setDone">
      <img src="/img/checkmark-white.svg">
      <span v-if="is_done">Realizado el {{ done_date }}</span>
      <span v-else>Realizar</span>
    </div>

    <div class="event-treatment-detail__minibtn" @click="addNote">
      Añadir Nota
    </div>

    <div class="event-treatment-detail__paid-status" :class="{ paid: is_paid }">
      <span v-if="is_paid">
        <svg style="margin-right: 2px;" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
          fill="none">
          <path
            d="M1.75999 9.95199L1.75999 8.38399L10.4 8.38399L10.4 9.95199L1.75999 9.95199ZM1.75999 7.74399L1.75999 6.17599L10.4 6.17599L10.4 7.74399L1.75999 7.74399ZM9.408 13.888C8.52266 13.888 7.70133 13.7493 6.94399 13.472C6.19733 13.184 5.54666 12.7787 4.99199 12.256C4.44799 11.7333 4.02133 11.12 3.71199 10.416C3.40266 9.70132 3.24799 8.91732 3.24799 8.06399C3.24799 7.21066 3.40266 6.43199 3.71199 5.72799C4.02133 5.01332 4.448 4.39466 4.992 3.87199C5.54666 3.34932 6.19733 2.94932 6.944 2.67199C7.70133 2.38399 8.52266 2.23999 9.408 2.23999C10.4427 2.23999 11.3653 2.42132 12.176 2.78399C12.9973 3.14666 13.68 3.66933 14.224 4.35199L12.208 6.17599C11.856 5.74932 11.4613 5.42399 11.024 5.19999C10.5867 4.97599 10.1013 4.86399 9.568 4.86399C9.10933 4.86399 8.688 4.93866 8.304 5.08799C7.93066 5.23732 7.60533 5.45599 7.328 5.74399C7.05066 6.02132 6.832 6.35732 6.672 6.75199C6.52266 7.14666 6.448 7.58399 6.448 8.06399C6.448 8.54399 6.52266 8.98132 6.672 9.37599C6.832 9.77066 7.05066 10.112 7.328 10.4C7.60533 10.6773 7.93066 10.8907 8.304 11.04C8.688 11.1893 9.10933 11.264 9.568 11.264C10.1013 11.264 10.5867 11.152 11.024 10.928C11.4613 10.704 11.856 10.3787 12.208 9.95199L14.224 11.776C13.68 12.448 12.9973 12.9707 12.176 13.344C11.3653 13.7067 10.4427 13.888 9.408 13.888Z"
            fill="#42B577" />
        </svg>
        Pagado {{ paid_date }}
      </span>
      <span v-else>
        Sin pagar
      </span>
    </div>

    <div class="event-treatment-detail__doctors" @click="assign">
      <div v-if="treatment.doctor_id">
        Asignado a: {{ doctor_name }}
      </div>
      <div class="event-treatment-detail__assign" v-else>
        Asignar ...
      </div>
      <div v-if="treatment.derived_by">
        Derivado por: {{ derived_by_name }}
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: ['treatment', 'event', 'doctor_names'],
  computed: {
    show_status() {
      return (this.event.entity == 'Appointment');
    },
    is_quotation() {
      return this.event.entity == 'Quotation';
    },
    is_appointment() {
      return this.event.entity == 'Appointment';
    },
    is_appointed() {
      return this.treatment.appointments && (this.treatment.appointments.length > 0);
    },
    is_done() {
      return this.treatment.status == 'done';
    },
    is_paid() {
      return this.treatment.is_paid;
    },
    paid_date() {
      return this.treatment.paid_at ?
        moment(this.treatment.paid_at).format('DD/MM/YY') : '';
    },
    done_date() {
      return this.treatment.done_at ?
        moment(this.treatment.done_at).format('DD/MM/YY') : '';
    },
    doctor_name() {
      if (!this.clinic || !this.treatment.doctor_id) return '';
      return this.doctor_names[this.treatment.doctor_id] || '';
    },
    derived_by_name() {
      if (!this.clinic || !this.treatment.derived_by) return '';
      return this.doctor_names[this.treatment.derived_by] || '';
    },
    ...mapGetters(['clinic'])
  },
  methods: {
    assign() {
      this.$emit('assign', this.treatment);
    },
    setDone() {
      this.$emit('done', this.treatment);
    },
    addNote() {
      this.$emit('note', this.treatment);
    },
    addAppointment() {
      if (!this.is_appointed) {
        this.$emit('appointment', this.treatment);
      }
    },
    openAgenda() {
      window.open('/agenda/', '_blank');
    }
  }
}
</script>

<style lang="scss">
.event-treatment-detail {
  &>*+* {
    margin-left: 10px;
  }


  &__title {
    font-size: 15px;
    font-weight: 700;
  }

  &__status {
    border-radius: 20px;
    background: var(--theme-color);
    padding: 5px 10px;
    color: white;
    font-size: 12px;
    line-height: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: .3s;
    cursor: pointer;
    font-weight: 700;
    vertical-align: middle;

    img {
      width: 12px;
      height: 12px;
      margin-right: 5px;
    }

    &.done {
      background: var(--theme-color-attended);
    }
  }

  &__is-appointed {
    border-radius: 20px;
    background: var(--theme-grey);
    padding: 5px 10px;
    color: white;
    font-size: 12px;
    line-height: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: .3s;
    cursor: pointer;
    font-weight: 700;
    vertical-align: middle;

    &:not(.appointed):hover {
      background: var(--theme-color-attended);
      cursor: default;
    }

    &.appointed {
      background: var(--theme-color-attended);
      cursor: default;
    }
  }

  &__minibtn {
    border-radius: 20px;
    background: var(--theme-color);
    padding: 5px 10px;
    color: white;
    font-size: 12px;
    line-height: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: .3s;
    cursor: pointer;
    font-weight: 700;
    vertical-align: middle;

    &:hover {
      opacity: 0.5;
    }
  }

  &__paid-status {
    color: var(--texto-gris, #A6AAB4);
    font-size: 12px;
    font-weight: 700;

    &.paid {
      color: var(--theme-color-attended);
    }
  }

  &+.event-treatment-detail {
    margin-top: 8px;
  }

  &__doctors {
    color: var(--theme-text-color);
    font-size: 12px;
    font-weight: 700;
    position: relative;
    padding-left: 10px;
    margin-left: 5px;
    cursor: pointer;
    transition: .3s;

    &::before {
      width: 2px;
      height: 15px;
      vertical-align: middle;
      margin: 0 10px;
      background: var(--texto-gris, #A6AAB4);
      content: '';
      left: -10px;
      top: 50%;
      transform: translateY(-50%);
      display: inline-block;
      position: absolute;
    }

    &:hover {
      color: var(--theme-color);
    }
  }

  &__assign {
    color: white;
    background-color: var(--theme-color);
    border-radius: 10px;
    padding: 0 10px;

    &:hover {
      opacity: 0.5;
    }
  }

}
</style>
